import React from 'react'
import { useNav } from '../hooks/useNav'
import { useUrlSearchParams } from '../hooks/useUrlSearchParams'
import getFormFields from '../utilities/getFormFields.js'

export default function usePgControls() {
    const [handleInputChange, handleValue, sessionObj, setDefault] =
        useUrlSearchParams()
    const [pgID, pgNav] = useNav(sessionObj)
    // const idRef = React.useRef('' + (Date.now() % 1000) + `-PgCntrls`)
    // console.log(`${idRef.current} in context`)

    function handlePgNav(direction) {
        // @ts-ignore
        pgNav(direction)
    }

    let controlSessionObj = {
        validFence: 'err' in sessionObj ? false : true,
        unitValue: sessionObj['unit'] || '', //  spacing values are dependent on unit values
        c_mats: sessionObj['c_mats'] || '', // hbrace values must be disabled pending mats values
        g_mats: sessionObj['g_mats'] || '',
        e_mats: sessionObj['e_mats'] || '',
    }

    let pgControlsArray = getFormFields(
        pgID,
        handleInputChange,
        handleValue,
        controlSessionObj
    )

    React.useEffect(() => {
        // console.log(`${idRef.current} in useEffect pgID is ${pgID}.
        //     entering React.useEffect in usePgControls calling setDefault`)

        // @ts-ignore
        setDefault(pgID)
    }, [pgID, setDefault])

    return [pgControlsArray, handlePgNav]
}
